import { Entity, Field } from 'typegraph';

import {IEntryVariants } from 'common/entities/courseWrapper/CourseWrapper';

@Entity({one: "entryVariant", many: "entryVariants"})
export default class EntryVariant implements IEntryVariants {

	@Field()
    public id: string;
    
    @Field()
	public price: number;
    
	@Field()
	public currency: string;	

}



// WEBPACK FOOTER //
// ./src/panels/bundleEntries/entities/EntryVariants.ts